<template>
  <el-card class="box-card" style="margin-top: 0;padding-top:0;">
    <div style="display:flex;font-size: 18px;line-height: 40px;">
      <b style="flex:1;">菜单详情</b>
    </div>
    <el-descriptions :column="1" size="normal" style="padding: 0 15px;">
      <el-descriptions-item label="菜单名称">{{ menuInfo.name || '--' }}</el-descriptions-item>
      <el-descriptions-item label="菜单类型">{{ getMenuTypeName(menuInfo.type) }}</el-descriptions-item>
      <el-descriptions-item label="权限码">{{ menuInfo.authCode || '--' }}</el-descriptions-item>
      <el-descriptions-item label="菜单地址">{{ menuInfo.menuUrl || '--' }}</el-descriptions-item>
      <el-descriptions-item label="图标">{{ menuInfo.icon || '--' }}</el-descriptions-item>
      <el-descriptions-item label="排序">{{ menuInfo.sort || 0 }}</el-descriptions-item>
      <el-descriptions-item label="系统标识">{{ menuInfo.sysFlag || '--' }}</el-descriptions-item>
      <el-descriptions-item label="关联接口地址">
        <div style="max-height: 100px; overflow-y: auto;">
          {{ menuInfo.authUrl || '--' }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="描述">{{ menuInfo.description || '--' }}</el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>

<script>
export default {
  name: 'MenuDetail',
  props: {
    menuInfo: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      menuTypeMap: {
        1: '模块',
        2: '菜单',
        3: '按钮',
      },
    };
  },
  methods: {
    getMenuTypeName (type) {
      return this.menuTypeMap[type] || '--';
    },
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  ::v-deep .el-card__body {
    padding: 20px;
  }
}
</style>
